import * as React from 'react';

interface IRadioInputComponent
{
	/** Признак отключения */
	IsDisabled: boolean,

	/** Текст */
	Value: boolean,

	/** Название поля */
	Label: any,

	/** Одинаковое имя группы для всех радио-батонов */
	Name: string,

	/**
	 *  Функция, выполняемая при изменении значения инпута
	 *  @value value - измененное значение инпута
	 */
	OnChange: (value: boolean) => void,

	/**
	 *  Функция, выполняемая при валидации значения (если элемент не задизаблен)
	 */
	OnValidate?: () => boolean,
}

export const RadioInputComponent: React.FC<IRadioInputComponent> =
	(
		// входные параметры компонента
		{ IsDisabled, Value, Label, Name, OnChange, OnValidate }: IRadioInputComponent
	) =>
	{
		// заворачиваем входные функции в CallBack
		const OnChangeCallback = React.useCallback((value: boolean) =>
		{
			OnChange(value);
			if (!IsDisabled && OnValidate) OnValidate();
		}, [OnChange, OnValidate, IsDisabled])

		return (
			<div className="formCheck">
				<label className="input-btns radio-btn">
					<input
						type="radio"
						name={Name}
						disabled={IsDisabled}
						onChange={(event: React.SyntheticEvent) => OnChangeCallback((event.target as HTMLInputElement).checked)}
						checked={Value}
					/>
					<span className="input-indicator"></span>
					<span>
						{Label}
					</span>
				</label>
			</div>
		)
	}
